import 'nodep-date-input-polyfill';
import Cookies from 'js-cookie';

class EligibilityWidget {

    constructor() {
        this.init();
    }

    init() {
        // Create date pickers
        $('.flatpickr').each((index, elt) => {
            $(elt).flatpickr({wrap: true, altInput: true, altFormat: 'm/d/Y', minDate: $(elt).children('input').attr('min'), maxDate: $(elt).children('input').attr('max')});
        });

        // Initialize first question
        this.initQuestion('q1');
    }

    initQuestion(id) {
        this.activeQuestionID = id;
        let questionElt = $('#' + id);

        questionElt.removeClass('d-none');

        switch (id) {
            case 'q1':
            case 'q4':
            case 'q5':
            case 'q6':
            case 'q7':
                questionElt.children('.question__answer').click((e) => this.answerClickHandler(e));
                break;
            case 'q8':
                // Baby is eligible
                Cookies.set('ec-eligibility', true, {expires: 1});
                break;

            case 'q2': {
                // Postnatal
                Cookies.set('ec-prenatal', 0, {expires: 1});
                Cookies.set('ec-postnatal', 1, {expires: 1});

                let form = questionElt.children('form');

                form.submit((e) => {
                    e.preventDefault();

                    if (!$('#q2date').val()) {
                        alert('Please enter a valid date');
                    }
                    // Check date (baby must be 4 weeks or younger)
                    else if (moment($('#q2date').val()).add(31, 'day').isSameOrAfter(moment(), 'day')) {
                        Cookies.set('ec-eligibility-baby-dob', $('#q2date').val(), {expires: 1});

                        this.unsetQuestion(id);
                        this.initQuestion('q4');
                    }
                    else {
                        form.addClass('d-none');
                        $('.question__head').addClass('d-none');

                        $('#q2msg').removeClass('d-none');

                        // Facebook pixel for ineligible users
                        window._fbq.push('trackCustom', 'Survey', {Survey_Name: 'EC', Group: 'Not Eligible'});
                    }
                });
                break;
            }

            case 'q3': {
                // Prenatal
                Cookies.set('ec-prenatal', 1, {expires: 1});
                Cookies.set('ec-postnatal', 0, {expires: 1});

                $('#q3form').submit((e) => {
                    e.preventDefault();

                    if (!$('#q3date').val()) {
                        alert('Please enter a valid date');
                    }
                    // Check date (mom must be past her first trimester)
                    else if (moment($('#q3date').val()).subtract(28, 'week').isSameOrBefore(moment(), 'day')) {
                        Cookies.set('ec-eligibility-due-date', $('#q3date').val(), {expires: 1});

                        this.unsetQuestion(id);
                        this.initQuestion('q6');
                    }
                    else {
                        $('#q3form').addClass('d-none');
                        $('.question__head').addClass('d-none');

                        $('#q3msg').removeClass('d-none');
                        $('#reminderForm').removeClass('d-none');

                        $('#reminderForm').submit((e) => {
                            e.preventDefault();

                            $('#reminderForm button').prop('disabled', true);

                            $.post('/api/addeligibilityreminder', $('#reminderForm').serialize()).done((data) => {
                                alert('Thank you. We will send you a reminder.');
                            });
                        });
                    }
                });
                break;
            }
        }
    }

    unsetQuestion(id) {
        let questionElt = $('#' + id);

        questionElt.addClass('d-none');

        switch (id) {
            case 'q1':
                questionElt.children('.question__answer').off('click', '**');
                break;

            case 'q2':
            case 'q3':
                questionElt.children('form').off('submit', '**');
                break;
        }
    }

    /** Event handlers **/
    answerClickHandler(e) {
        let answer = $(e.currentTarget);

        switch (this.activeQuestionID) {
            case 'q1':
                this.unsetQuestion(this.activeQuestionID);
                this.initQuestion(answer.attr('data-next'));
                break;

            case 'q4':
            case 'q5':
            case 'q6':
            case 'q7':
                if (answer.attr('data-next') == 'msg') {
                    $(answer).siblings('.msg').removeClass('d-none');
                    $('.question__head').addClass('d-none');
                    $('.question__answer').addClass('d-none');

                    // Facebook pixel for ineligible users
                    window._fbq.push('trackCustom', 'Survey', {Survey_Name: 'EC', Group: 'Not Eligible'});
                }
                else {
                    this.unsetQuestion(this.activeQuestionID);
                    this.initQuestion(answer.attr('data-next'));
                }

                break;
        }
    }
}

new EligibilityWidget();
